import { useCallback, useEffect } from 'react';

import { bridgeAtom, isLoadingMessageAtom, messageTimeoutAtom, useAtom, useSetValue, useValue } from '@/store';

import { getProductIdType } from '@/utils';

import { messages } from '@/modules/api';
import { MessageReasonType } from '@/modules/models';

export const useMessageTimeout = () => {
  const setIsLoadingMessage = useSetValue(isLoadingMessageAtom);
  const [messageTimeout, setMessageTimeout] = useAtom(messageTimeoutAtom);

  const { pageType, productId, variantId } = useValue(bridgeAtom);

  const send = useCallback(async () => {
    try {
      const { product_id: id, pageType: type } = getProductIdType({
        pageType,
        product_id: productId,
      });

      setMessageTimeout(-1);
      await messages({
        reason: MessageReasonType.TIMEOUT,
        variantId,
        pageType: type,
        productId: id,
        clientTimestamp: Date.now(),
      });
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingMessage(false);
    }
  }, [pageType, productId, variantId, setMessageTimeout, setIsLoadingMessage]);

  useEffect(() => {
    if (messageTimeout > 0) {
      setIsLoadingMessage(true);
      const timeoutId = setTimeout(send, messageTimeout);
      return () => clearTimeout(timeoutId);
    }
  }, [messageTimeout, setIsLoadingMessage]);

  return [messageTimeout, setMessageTimeout];
};
